import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { DataRoomResponse } from '../models/data';

export const onGetCompanyDocuments = async () => {
	try {
		const response = await axios.get<JsonResponse<DataRoomResponse>>('dashboard/company-documents');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
